import { Palette } from "@mui/material";
import { getOutlinedCardStyle } from "@utils/cssStyles";

export const mcqContainerSx = (palette: Palette) => ({
  ...getOutlinedCardStyle(palette, 2),
  p: 2,
  mb: 1,
});

export const mcqOptionSx = (
  palette: Palette,
  isSelected: boolean,
  selected: number | null,
) => ({
  border: `1px solid ${
    isSelected ? palette.secondary.dark : palette.text.borderLine
  }`,
  borderRadius: 1.5,
  p: 1.5,
  cursor: selected === null ? "pointer" : "default",
  backgroundColor: isSelected ? palette.text.input : "transparent",
  "&:hover": {
    borderColor: selected === null ? palette.secondary.dark : undefined,
    backgroundColor: selected === null ? palette.text.input : undefined,
  },
  opacity: selected !== null && !isSelected ? 0.6 : 1,
});

export const mcqQuestionSx = (palette: Palette) => ({
  color: palette.text.heading,
  mb: 1,
});

export const mcqHintSx = (palette: Palette) => ({
  display: "block",
  color: palette.text.label,
  mb: 1.5,
});
